import ADPMenuService from "../../../../services/admin/ADPMenuService";
import ADPModuleService from "../../../../services/admin/ADPModuleService";

class menuService {

    async getClientState(): Promise<any> {
        const clientState = localStorage.getItem('clientState');
        return clientState ? JSON.parse(clientState) : null
    }

    async getADPMenuTree(objectId: any): Promise<any> {
        const menuTree = await ADPMenuService.getADPMenuTree(objectId);
        return menuTree ? JSON.parse(menuTree) : null
    }

    async getMenuSetDropdownByObjectType(objectType: string): Promise<any> {
        return await ADPMenuService.getDropdownByObjectType(objectType);
    }

    async getMenuById(objectId: any): Promise<any> {
        return await ADPMenuService.getItemById(objectId);
    }

    async getModuleDropdown(): Promise<any> {
        return await ADPModuleService.getDropdown();
    }

    async create(item: any): Promise<any> {
        return await ADPMenuService.create(item);
    }

    async update(item: any): Promise<any> {
        return await ADPMenuService.update(item.objectId, item);
    }

    async deleteMenuTree(objectId: any): Promise<any> {
        return await ADPMenuService.deleteMenuTree(objectId);
    }

}

export default new menuService();
